import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


import { BadgeSize, BadgeType } from '../badge/entities/badge.entity';
import { IconSize, ShIconModule } from '../icon/icon.module';

@Component({
    standalone: true,
    selector: 'sh-icon-badge',
    templateUrl: './icon-badge.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShIconModule]
})
export class ShIconBadgeComponent {
    public readonly iconSize: IconSize = IconSize.SMALL;

    @Input() type: BadgeType = BadgeType.UPDATE;
    @Input() count: number | undefined;
    @Input() size: BadgeSize = BadgeSize.REGULAR;
    @Input() icon: string;
}
